import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bottom" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "sim-card",
    style: _normalizeStyle({
      backgroundImage:
        `url(` + require(`@/assets/screenshots/${_ctx.sim.screenshots[0]}`) + `)`,
    })
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "grow" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "title",
        href: _ctx.sim.github,
        target: "_blank"
      }, _toDisplayString(_ctx.sim.title), 9, _hoisted_2),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.sim.description), 1)
    ])
  ], 4))
}